import React from 'react'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import { Link } from 'react-router-dom'
import CountUp from 'react-countup'
import { all_routes } from '../../../router/all_routes'

const Knowledge = () => {
    const route = all_routes
    return (
        <>
            {/* Share your knowledge */}
            <section className="share-knowledge-five">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-sm-12" data-aos="fade-down">
                            <div className="section-five-sub">
                                <div className="header-five-title mb-0">
                                    <p>PARTNERS INSTITUTIONS</p>
                                    <h2>Supporting Partner Institutions to Thrive</h2>
                                </div>
                                <div className="career-five-content">
                                    <p>
                                        High-definition video is video of higher resolution and quality
                                        than standard-definition.{" "}
                                    </p>
                                </div>
                                <ul className="list-unstyled heading-color mb-4">
                                    <li className="d-flex mb-3">
                                        <i className="isax isax-tick-circle5 text-success fs-24 me-2" />
                                        Attract a diverse student body representing over 150 nationalities to enrich your campus community.
                                    </li>
                                    <li className="d-flex mb-3">
                                        <i className="isax isax-tick-circle5 text-success fs-24 me-2" />
                                        Receive higher-quality applications and boost your conversion rates by 10%.
                                    </li>
                                    <li className="d-flex mb-3 aos-init aos-animate">
                                        <i className="isax isax-tick-circle5 text-success fs-24 me-2" />
                                        Utilize proven technology to streamline your admissions process, saving up to 40% in time and reducing manual work.
                                    </li>
                                </ul>
                                <Link to={route.institutionHome} className="btn btn-primary">
                                    Partner with Us
                                </Link>
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-12" data-aos="fade-down">
                            <div className="joing-count-five text-center">
                                <div className="joing-count-image">
                                    <ImageWithBasePath src="assets/img/feature/feature-7.png" alt="Img" />
                                    <ImageWithBasePath
                                        src="./assets/img/shapes/dot-2.svg"
                                        alt="img"
                                        className="joing-count-img1"
                                    />
                                    <ImageWithBasePath
                                        src="./assets/img/shapes/half-circle.svg"
                                        alt="img"
                                        className="joing-count-img2"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* /Share your knowledge */}
        </>

    )
}

export default Knowledge
